export const dataFormType = {
    input: 'input',
    radio: 'radio',
    select: 'select',
    checkbox: 'checkbox',
    checkboxSingle: 'checkboxSingle',
    textarea: 'textarea'
}
